import React, { useEffect } from "react";
import { Form, Grid, Message } from "@arco-design/web-react";
import { useRef, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { TEXTS } from "./PasswordFieldText/PasswordFieldText";
import {
  getAllUrlParams,
  getLocalStorage,
  handleApiError,
  removeLeadingSpace,
  removeLocalStorage,
  removeSpaces,
  setLocalStorage,
} from "../../../../../common/Utils/Utils";
import { useLoader } from "../../../../../common/Context/LoaderContext";
import { useAlert } from "../../../../../common/Context/AlertContext";
import InputField from "../../../../InputField/InputField";
import { ManageApis } from "../../../../../common/APIS/ManageApis";
import { forgotPasswordField } from "../../ForgetEmailVerification/forgotPasswordEmailField";
import { validateToken } from "../../../../../common/functions/ValidateToken/ValidateToken";
import notify from "../../../../../common/Utils/toastService";
function PasswordField() {
  const [searchParams] = useSearchParams();
  const formRef = useRef();
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const urlParams = getAllUrlParams(true);
  const Token = urlParams
    ? decodeURIComponent(urlParams?.token).replace(/\s/g, "+")
    : null;
  setLocalStorage("AuthToken", Token);
  setLocalStorage("userId", urlParams?.userId);
  const authgetToken = getLocalStorage("AuthToken");
  const usergetId = getLocalStorage("userId");
  const [tokenValidated, setTokenValidated] = useState(false);
  const [validatingToken, setValidatingToken] = useState(true);

  useEffect(() => {
    if (!authgetToken) {
      navigate("/login");
    }
  }, [Token]);

  useEffect(() => {
    validateToken(
      setValidatingToken,
      setTokenValidated,
      authgetToken,
      usergetId,
      showAlert,
      navigate
    );
  }, []);

  const handleSubmit = async () => {
    const isValid = await form.validate();
    if (!isValid) {
      console.log("Validation failed. Please check the form.");
      return;
    }
    try {
      setLoading(true);
      const fields = form.getFieldsValue();
      const reqBody = {
        userId: usergetId,
        token: authgetToken,
        newPassword: fields.password,
      };
      const response = await ManageApis(
        "post",
        window.resetPassword,
        reqBody,
        ""
      );
      const { status_code, message, response_data } = response || {};
      const { status, message: responseMessage = "" } = response_data || {};
      if (status_code === 200 || message === "Success") {
        notify.success(responseMessage);
        removeLocalStorage("AuthToken");
        removeLocalStorage("userId");
        navigate("/login");
      } else if (status_code == 400) {
        notify.success(message || "Something went wrong");
        removeLocalStorage("AuthToken");
        removeLocalStorage("userId");
        navigate("/login");
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.error("API call failed:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (value, field) => {
    const valueWithoutLeadingSpace = removeLeadingSpace(value);

    switch (field) {
      case "password":
      case "confirmPassword":
        const sanitizedPassword = removeSpaces(value);
        form.setFieldValue(field, sanitizedPassword);
        break;
      default:
        form.setFieldValue(field, valueWithoutLeadingSpace);
        break;
    }
  };
  return (
    <>
      <div className="w-100">
        <div
          className="p-3 p-md-0 mx-auto registerMain loginMain"
          style={{ minWidth: "460px", height: "400px", alignContent: "center" }}
        >
          {validatingToken ? (
            <div>
              <h3 className="font_22 fw_600">{TEXTS.verifyingTitle}</h3>
              <p className="font_13 font_500 text_gray10 mb-4">
                {TEXTS.verifyingDescription}
              </p>
            </div>
          ) : tokenValidated ? (
            <>
              <h3 className="font_22 fw_600">{TEXTS.resetPasswordTitle}</h3>
              <p className="font_12 font_500 text_gray10 mb-4">
                {TEXTS.resetPasswordDescription}
              </p>
              <div className="customForm">
                <Form form={form} autoComplete="off" onSubmit={handleSubmit}>
                  <Form.Item>
                    <div className="customInput">
                      <Grid.Row style={{ alignItems: "center" }} gutter={12}>
                        {forgotPasswordField(form).map((field) => (
                          <InputField
                            inputStyle={{ height: "42px" }}
                            key={field.field}
                            value={form.getFieldValue(field.field)}
                            onChange={(value) =>
                              handleInputChange(value, field.field)
                            }
                            {...field}
                          />
                        ))}
                      </Grid.Row>
                    </div>
                    <div className="position-relative">
                      <button
                        type="submit"
                        style={{ height: "35px", fontSize: "13px" }}
                        className="w-100 btn1 btn-primary1 rounded fw_500 px-4 mt-3"
                      >
                        Submit
                      </button>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default PasswordField;
